module.exports = __webpack_public_path__ + "img/arrow.a1fd2570.png";